import { ref } from 'vue';

/**
 * Composable to trigger balance refresh across components
 * Used when operations change token balance (registration, market creation with fees)
 */

const refreshTrigger = ref(0);

export function useBalanceRefresh() {
  function triggerRefresh() {
    refreshTrigger.value++;
  }

  return {
    refreshTrigger,
    triggerRefresh,
  };
}
